import { BACKEND_URL } from "./backend-config";
import { getSocket } from "./socket";

export type FulltextPolicy = "auto" | "warn" | "none";

export interface UploadResult {
  fileId: string;
  filename: string;
  policy: FulltextPolicy;
  tokenEstimate: number;
  text?: string;
}

export async function uploadFile(file: File, spentTokens: number): Promise<UploadResult> {
  const socket = getSocket();

  const form = new FormData();
  form.append("file", file);
  form.append("spentTokens", String(spentTokens));

  const res = await fetch(`${BACKEND_URL}/api/upload`, {
    method: "POST",
    headers: { "x-socket-id": socket.id ?? "" },
    body: form,
  });

  if (!res.ok) {
    const msg = await res.text().catch(() => res.statusText);
    throw new Error(`Upload failed (${res.status}): ${msg}`);
  }

  return res.json() as Promise<UploadResult>;
}
